const asyncActionType = type => ({
  pending: `${type}/PENDING`,
  success: `${type}/SUCCESS`,
  error: `${type}/ERROR`
});

export const FORM_ANSWERS_LIST = asyncActionType('aerosimple/form/FORM_ANSWERS_LIST');
export const PUBLISHED_FORM = asyncActionType('aerosimple/form/PUBLISHED_FORM');
export const CREATE_FORM_ANSWER = asyncActionType('aerosimple/form/CREATE_FORM_ANSWER');
export const FORMS_PUBLISHED_LIST = asyncActionType('aerosimple/form/FORMS_PUBLISHED_LIST');
export const PORTAL_FORMS_GET_SCHEMA = asyncActionType('aerosimple/form/PORTAL_FORMS_GET_SCHEMA');
export const GET_PORTAL_USERS_LIST_FOR_PORTAL_FIELD = asyncActionType('aerosimple/form/GET_PORTAL_USERS_LIST_FOR_PORTAL_FIELD');
export const CLEAR_LOADING_ACTIONS = asyncActionType('aerosimple/form/CLEAR_LOADING_ACTIONS');
export const FETCH_DATA_SOURCE_FORM_DETAILS = asyncActionType('aerosimple/form/FETCH_DATA_SOURCE_FORM_DETAILS');
export const FORM_ANSWER_DETAILS = asyncActionType('aerosimple/form/FORM_ANSWER_DETAILS');
export const APPROVE_FORM_ANSWER = asyncActionType('aerosimple/form/APPROVE_FORM_ANSWER');
export const REJECT_FORM_APPROVAL = asyncActionType('aerosimple/form/REJECT_FORM_APPROVAL');
export const PORTAL_FORMS_GET_APPROVALS_LIST = asyncActionType('aerosimple/form/PORTAL_FORMS_GET_APPROVALS_LIST');
export const PORTAL_APPROVAL_SEND_BACK = asyncActionType('aerosimple/form/PORTAL_APPROVAL_SEND_BACK');
export const PORTAL_APPROVAL_SEND_BACK_WITH_DATA = asyncActionType('aerosimple/form/PORTAL_APPROVAL_SEND_BACK_WITH_DATA');
export const SAVE_FORMS_VIEW_TAB = asyncActionType('aerosimple/form/SAVE_FORMS_VIEW_TAB');
export const CLEAR_FORM_DETAILS = asyncActionType('aerosimple/form/CLEAR_FORM_DETAILS');
export const UPDATE_FORM_ANSWER = asyncActionType('aerosimple/form/UPDATE_FORM_ANSWER');
export const GET_SELECTED_USERS = asyncActionType('aerosimple/form/GET_SELECTED_USERS');
export const DELETE_FORM_ANSWER = asyncActionType('aerosimple/form/DELETE_FORM_ANSWER');
